import React, { useState, useEffect } from "react";
import NavHeader from "../../Common/NavHeader";
import BreadCrumb from "../../Common/BreadCrumb";
import Paginator from "../../Common/Paginator";
import {
  getLaborClassification,
  changeLaborClassCategory,
  searchLabor,
} from "../api";
import useAppStore from "../../../store/global";
import { Spinner } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import LaborTable from "./LaborTable";
import { toast, ToastContainer } from "react-toastify";
import { Form, FormControl, Button, InputGroup } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import ManualClassificationModal from "../../Common/ExportModal";


export default function LaborClassHome() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const restName = queryParams.get('restaurant_name');

  const [reports, setReports] = useState([]);
  const { loading, setLoading, pageSize } = useAppStore();
  const [approveLoading, setApproveLoading] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { id } = useParams();

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const fetchLabor = () => {
    setLoading(true);
  
    console.log("searchTerm", searchTerm);
    const apiCall = searchTerm && searchTerm.length > 0 ? searchLabor : getLaborClassification;
  
    apiCall({restaurant_id:id, title:searchTerm, pageNum:pageNum, pageSize:pageSize})
      .then((data) => {
        if (searchTerm && searchTerm.length > 0) {
          setReports(data.results);
        } else {
          setReports(data.labor_objects);
          setTotalPages(data.totalPages);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  };
  
  const handleCategoryChange = (labor_id, category,restaurant_id) => {
    setApproveLoading(true);
    changeLaborClassCategory(labor_id, category,restaurant_id)
      .then((data) => {
        toast.success(data.message);
        setApproveLoading(false);
        fetchLabor();
      })
      .catch((err) => {
        setApproveLoading(false);
        toast.error(err.message);
      });
  };
  
  useEffect(() => {
    fetchLabor();
  }, [pageNum, searchTerm]);


  
  return (
    <>
      <NavHeader view="scrapper" />
      <div className="mx-2 mx-md-4" style={{ marginTop: "100px" }}>
        <BreadCrumb text={`Restaurants > ${restName} > Labor Classification`} />
        <Form className="mt-3 mb-3 w-100 d-flex justify-content-between">
          <Form.Group controlId="searchBar" className="d-flex w-50">
            <InputGroup>
              <FormControl
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
                <Button variant="outline-secondary">
                  <Search />
                </Button>
            </InputGroup>
          </Form.Group>
         <Button variant="primary" onClick={handleShowModal}>
            Bulk Approve
          </Button> 
        </Form>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <>
            <LaborTable
              reports={reports}
              handleCategoryChange={handleCategoryChange}
              approveLoading={approveLoading}
              restaurant_id={id}
            />
            <Paginator
              pageNum={pageNum}
              setPageNum={setPageNum}
              totalPages={totalPages}
            />
            <ManualClassificationModal
              showModal={showModal}
              handleCloseModal={handleCloseModal}
            />
          </>
        )}
      </div>
      <ToastContainer />
    </>
  );
}
